export default __webpack_public_path__ + "static/media/hand_icon.1e3f49eb.svg";